export const Name = 'toggle-favorite';
export const ToggleFavorite = Name;
